import { render } from "./howitworks.vue?vue&type=template&id=7330ae06&scoped=true"
import script from "./howitworks.vue?vue&type=script&lang=js"
export * from "./howitworks.vue?vue&type=script&lang=js"

import "./howitworks.vue?vue&type=style&index=0&id=7330ae06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7330ae06"

export default script